// Generated by CoffeeScript 2.7.0
var Ajax, Message, MessageList, STORAGE_KEY, adminUrlFor;

import Popover from './popover.js';

import MessageGroupsSelect from 'trunks/vue/admin/compositions/message_groups_select.js';

import TagsSelect from 'trunks/vue/admin/compositions/tags_select.js';

({adminUrlFor} = Skylark.Helpers.UrlHelper);

({Ajax} = Skylark.Libs);

STORAGE_KEY = 'message_list_element_pinned_counter_open';

Message = class Message {
  constructor(element) {
    var message_group_ids_str, tag_ids_str;
    this.element = DomMaster.wrap(element);
    this.tags_popover_el = this.element.find('.tags-popover');
    this.message_groups_popover_el = this.element.find('.message-groups-popover');
    if (this.tag_ids == null) {
      this.tag_ids = _.isString(tag_ids_str = this.element.data('tag-ids')) ? _.compact(_.map(tag_ids_str.split(','), function(id) {
        return parseInt(id);
      })) : [];
    }
    if (this.message_group_ids == null) {
      this.message_group_ids = _.isString(message_group_ids_str = this.element.data('message-group-ids')) ? _.compact(_.map(message_group_ids_str.split(','), function(id) {
        return parseInt(id);
      })) : [];
    }
    this.element.node.proxy('click', '.pin-btn', (event) => {
      var url;
      url = adminUrlFor(`messages/${this.element.data('id')}/toggle_pin`);
      return Ajax.patch(url, {
        responseType: 'script'
      });
    });
    this.element.node.proxy('click', '.tag-btn', (event) => {
      if (this.tags_popover == null) {
        this.tags_popover = new Popover(this.tags_popover_el, {
          size: 'default',
          type: 'select',
          beforeOpenFunc: (popover) => {
            this.element.addClass('active');
            if (this.tag_select) {
              return this.tag_select.reset();
            } else {
              this.tag_select = new TagsSelect({
                el: this.element.find('.tags-edit-container').node,
                propsData: {
                  initialSelectedTagIds: this.tag_ids
                }
              });
              return this.tag_select.$on('optionsChanged', function() {
                return popover.__calculatePosition();
              }).$on('cancelClicked', () => {
                return this.tags_popover.close();
              }).$on('submitClicked', (value) => {
                var url;
                url = adminUrlFor(`messages/${this.element.data('id')}/tags`);
                return Ajax.patch(url, {
                  responseType: 'script',
                  contentType: "application/json; charset=UTF-8",
                  data: {
                    tag_ids: value
                  },
                  success: function() {
                    return Skylark.Bridge.newAlertify('更新成功', {
                      type: 'success'
                    });
                  }
                });
              });
            }
          },
          beforeCloseFunc: (popover) => {
            return this.element.removeClass('active');
          }
        });
      }
      return this.tags_popover.open();
    });
    this.element.node.proxy('click', '.group-btn', (event) => {
      if (this.groups_popover == null) {
        this.groups_popover = new Popover(this.message_groups_popover_el, {
          size: 'default',
          type: 'select',
          beforeOpenFunc: (popover) => {
            this.element.addClass('active');
            if (this.message_group_select) {
              return this.message_group_select.reset();
            } else {
              this.message_group_select = new MessageGroupsSelect({
                el: this.element.find('.message-groups-edit-container').node,
                propsData: {
                  initialSelectedMessageGroupIds: this.message_group_ids
                }
              });
              return this.message_group_select.$on('optionsChanged', function() {
                return popover.__calculatePosition();
              }).$on('cancelClicked', () => {
                return this.groups_popover.close();
              }).$on('submitClicked', (value) => {
                var url;
                url = adminUrlFor(`messages/${this.element.data('id')}/message_groups`);
                return Ajax.patch(url, {
                  responseType: 'script',
                  contentType: "application/json; charset=UTF-8",
                  data: {
                    message_group_ids: value
                  },
                  success: function() {
                    return Skylark.Bridge.newAlertify('更新成功', {
                      type: 'success'
                    });
                  }
                });
              });
            }
          },
          beforeCloseFunc: (popover) => {
            return this.element.removeClass('active');
          }
        });
      }
      return this.groups_popover.open();
    });
  }

};

export default MessageList = class MessageList {
  constructor(container) {
    this.container = container;
    this.is_counter_open = false;
    this.group_boards = {
      pinned: this.container.find('.pinned-messages'),
      pinned_counter: this.container.find('.pinned-counter-board')
    };
    this.container = DomMaster.wrap(this.container);
    this._init();
    if (localStorage.getItem(STORAGE_KEY) && this._messageItemsCount(this._getMessageBoard('pinned')) > 0) {
      this._openPinnedCounter();
    }
  }

  pinMessage(id, group_names, content) {
    var board, closest_board_el, id_selector, message_item_el;
    id_selector = `#receiptable_timeline_${id}`;
    message_item_el = this.container.find(id_selector);
    closest_board_el = message_item_el.closest('.board');
    message_item_el.remove();
    this._rerenderBoard(closest_board_el);
    board = this._getMessageBoard(group_names);
    if (board.isPresent()) {
      board.find('.message-list').prepend(content);
      new Message(board.find(id_selector));
    }
    if (!this.is_counter_open) {
      this._getMessageBoard('pinned').show();
    }
    return this._updateCounterText();
  }

  unpinMessage(id, group_names, content) {
    var board, id_selector;
    id_selector = `#receiptable_timeline_${id}`;
    this.container.find(id_selector).remove();
    board = this._getMessageBoard(group_names);
    if (board.isPresent()) {
      board.find('.message-list').append(content);
      board.show();
      new Message(board.find(id_selector));
    }
    if (!this.is_counter_open) {
      this._rerenderBoard(this._getMessageBoard('pinned'));
    }
    return this._updateCounterText();
  }

  updateMessage(id, content) {
    var element;
    element = this.container.find(`#receiptable_timeline_${id}`);
    if (element.isPresent()) {
      element.replaceWith(content);
      return new Message(this.container.find(`#receiptable_timeline_${id}`));
    }
  }

  _init() {
    _.each(this.container.findAll('.message-item'), function(message_item) {
      if (!message_item.containsClass('pinned-counter')) {
        return new Message(message_item);
      }
    });
    this.container.node.proxy('click', '.pinned-messages .collapse-btn', (event) => {
      return this._openPinnedCounter();
    });
    return this.container.node.proxy('click', '.pinned-counter-board', (event) => {
      return this._closePinnedCounter();
    });
  }

  _getMessageBoard(group_names) {
    var board;
    board = null;
    _.each(group_names.split(','), (group_name) => {
      var base;
      if ((base = this.group_boards)[group_name] == null) {
        base[group_name] = this.container.find(`.board[data-group-name='${group_name}']`);
      }
      return board != null ? board : board = this.group_boards[group_name].presence();
    });
    return board != null ? board : board = DomMaster.none();
  }

  _messageItemsCount(board) {
    return board.findAll('.message-item').length;
  }

  _rerenderBoard(board) {
    if (!board.isPresent()) {
      return;
    }
    if (this._messageItemsCount(board) > 0) {
      return board.show();
    } else {
      return board.hide();
    }
  }

  _updateCounterText() {
    return this._getMessageBoard('pinned_counter').find('.messages-count').html(`消息 ${this._messageItemsCount(this._getMessageBoard('pinned'))}`);
  }

  _openPinnedCounter() {
    this.is_counter_open = true;
    localStorage.setItem(STORAGE_KEY, 1);
    this._getMessageBoard('pinned_counter').show();
    return this._getMessageBoard('pinned').hide();
  }

  _closePinnedCounter() {
    this.is_counter_open = false;
    localStorage.removeItem(STORAGE_KEY);
    this._getMessageBoard('pinned_counter').hide();
    return this._getMessageBoard('pinned').show();
  }

};
